module.exports = __webpack_public_path__ + "img/ab-banner.e9937bcd.png";